<template>
  <div id="account-metrics">
    <v-card elevation="2" class="pa-6" height="321px">
      <v-row class="no-gutters">
        <v-col cols="8">
          <div
            v-text="'Metrics'"
            class="heading font--secondary text-h5-heading font-weight-600"
          />
        </v-col>
        <v-col cols="4">
            <v-overflow-btn
            v-model="selectedDayFilter"
            :items="daysFilterData"
            label="Filter Days"
            item-text="name"
            attach
            item-value="value"
            outlined
            @change="fetchResources"
            dense
            short
            hide-details
            item-color="rgba(0,0,0,0.87)"
            class="text-capitalize body-2"
          />
        </v-col>
      </v-row>

      <loader :loading="isLoading" />
      <marketing-cloud-usage
        v-if="currentAccount.enable_marketing && isMarketingSelected"
        :days="selectedDayFilter"
        :emails-usage-stats="emailsUsageStats"
        :sms-usage-stats="smsUsageStats"
      />
      <service-cloud-usage v-else :days="selectedDayFilter" />
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UsageCard from "./UsageCard.vue";
import ServiceCloudUsage from "./ServiceCloudUsage.vue";

import Loader from "@core/components/shared/Loader.vue";
import { $selfService, $widgets } from "@core/services";
import MarketingCloudUsage from "./MarketingCloudUsage.vue";

import constants from "@core/config/constants.js";
const { MAROPOST_PRODUCTS } = constants;

export default {
  name: "AccountMetrics",
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  props: {
    selectedProduct: {
      type: String,
      default: "",
      required: true
    }
  },
  /**
  |--------------------------------------------------
  | Components
  |--------------------------------------------------
  */
  components: {
    UsageCard,
    ServiceCloudUsage,
    MarketingCloudUsage,
    Loader
  },
  /**
  |--------------------------------------------------
  | Computed properties
  |--------------------------------------------------
  */
  computed: {
    isMarketingSelected() {
      return MAROPOST_PRODUCTS.marketingCloud === this.selectedProduct;
    },
    ...mapGetters({
      user: "auth/userdata",
      account: "auth/account",
      currentAccount: "auth/account.current",
      packageFeatures: "auth/packageFeatures"
    })
  },
  /**
  |--------------------------------------------------
  | Data Properties
  |--------------------------------------------------
  */
  data() {
    const daysFilterData = Object.freeze([
      { name: "Monthly", value: 30 },
      { name: "Yearly", value: 365 }
    ]);
    return {
      daysFilterData,
      ticketsUsageStats: { allocated: 0, used: 0 },
      emailsUsageStats: { allocated: 0, used: 0 },
      smsUsageStats: { allocated: 0, used: 0 },
      emailsUsage: 0,
      smsStats: {},
      selectedDayFilter: daysFilterData[0].value,
      isLoading: false
    };
  },
  /**
  |--------------------------------------------------
  | Methods
  |--------------------------------------------------
  */
  methods: {
    async getSmsUsage() {
      const {
        data: { data }
      } = await $selfService.getSmsUsage(this.account.id);

      this.smsUsageStats.used = data.total_sms_received + data.total_sms_sents;
    },
    async getEmailVolume() {
      const option = this.daysFilterData.find(
        ({ value }) => this.selectedDayFilter === value
      );

      const params = {
        options: (option && option.name.toLowerCase()) || "monthly"
      };

      const { data } = await $widgets.getMonthlyEmailUsage({ params });

      this.emailsUsageStats.used = data.data.sent_email || 0;
      this.emailsUsageStats.allocated = data.data.alloted_emails || 0;
    },
    /**
    |--------------------------------------------------
    | Fetch resources
    |--------------------------------------------------
    */
    async fetchResources() {
      try {
        this.isLoading = true;
        if(this.currentAccount.enable_marketing){
          await Promise.all([this.getSmsUsage(), this.getEmailVolume()]);
        }
      } finally {
        this.isLoading = false;
      }
    }
  },

  async mounted() {
    this.fetchResources();
  }
};
</script>